<div class="whatsapp">
  <a [href]="whatsappUrl" target="_blank">
    <i class="fab fa-whatsapp whatsapp-icon"></i>
  </a>
</div>
